/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {SurveyFormInputBoolean} from "../SurveyFormInputBoolean";
import {SurveyFormInputFile} from "../SurveyFormInputFile";
import {SurveyFormComposedInput} from "../SurveyFormComposedInput";

export const SurveyFormBooleanWithFileInput = (props) => 
    <SurveyFormComposedInput Validation={props.Validation}>
        <SurveyFormInputBoolean {...props} Validation={null}/>
        <SurveyFormInputFile {...props} Validation={null}/>
    </SurveyFormComposedInput>;
